module.exports = __webpack_public_path__ + "static/media/ARCADECLASSIC.96411199.TTF";